{
  "add_choice": "Hoe wil je stembureaus toevoegen?",
  "address": "Straatnaam en huisnummer",
  "create": "Stembureau toevoegen",
  "export": "Lijst exporteren",
  "edit_not_allowed_alert": {
    "description": "De invoerfase van de eerste zitting is al gestart. Na het starten van de invoerfase kan alleen een coördinator de lijst met stembureaus nog bewerken.",
    "title": "Stembureaus kunnen niet aangepast worden"
  },
  "import": "Stembureaus importeren",
  "import_subtitle": "Importeer stembureaus gemeente {location}",
  "import_instructions": "Kies het bestand met de stembureaus.",
  "delete": "Stembureau verwijderen",
  "delete_modal": {
    "action_cannot_be_reverted": "Deze actie kan niet worden teruggedraaid.",
    "existing_data_entry": "<strong>Let op:</strong> Er is in deze zitting invoer voor dit stembureau gedaan. De invoer wordt ook verwijderd. ",
    "existing_investigation": "<strong>Let op:</strong> Er is in deze zitting een onderzoek voor dit stembureau aangemaakt. Het onderzoek wordt ook verwijderd. ",
    "existing_investigation_and_data_entry": "<strong>Let op:</strong> Er is in deze zitting een onderzoek voor dit stembureau aangemaakt én invoer gedaan. Het onderzoek en de invoer worden ook verwijderd. ",
    "title": "Stembureau verwijderen?"
  },
  "delete_not_possible": {
    "pre_existing_polling_station": "Er zijn al tellingen ingevoerd voor dit stembureau in een eerdere zitting.",
    "title": "Stembureau verwijderen niet mogelijk"
  },
  "details": "Details van het stembureau",
  "empty": "Er zijn nog geen stembureaus ingevoerd voor deze verkiezing. Kies hoe je stembureaus gaat toevoegen.",
  "form": {
    "not_unique": {
      "description": "Het nummer van het stembureau moet uniek zijn.",
      "error": "Voer een uniek nummer in",
      "title": "Er bestaat al een stembureau met nummer {number}."
    },
    "save_create": "Opslaan en toevoegen",
    "save_update": "Wijzigingen opslaan"
  },
  "house_number": "Huisnummer",
  "house_number_addition": "Toevoeging",
  "locality": "Plaats",
  "manage": "Stembureaus beheren",
  "message": {
    "delete_error_title": "Stembureau kan niet verwijderd worden",
    "no_polling_stations": "Er zijn nog geen stembureaus ingevoerd voor deze verkiezing. Kies hoe je stembureaus gaat toevoegen.",
    "polling_station_created": "Stembureau {number} ({name}) toegevoegd",
    "polling_station_deleted": "Stembureau {number} ({name}) verwijderd",
    "polling_station_updated": "Stembureau {number} ({name}) aangepast",
    "polling_stations_imported": "Er zijn {number} stembureaus geïmporteerd"
  },
  "postal_code": "Postcode",
  "recounted_question": "Is er herteld?",
  "title": {
    "address": "Adres van het stembureau",
    "how_to_add": "Hoe wil je stembureaus toevoegen?",
    "plural": "Stembureaus",
    "singular": "Stembureau",
    "type": "Soort stembureau"
  },
  "type": {
    "FixedLocation": "Vaste locatie",
    "Mobile": "Mobiel",
    "Special": "Bijzonder",
    "SpecialExplanation": "Bijzonder (afwijkende openingstijden)",
    "Unknown": "Onbekend"
  },
  "update": "Stembureaugegevens wijzigen",
  "voters_and_vote_count": "Aantal kiezers en stemmen",
  "warning_completed": {
    "description": "Als je wijzigingen aanbrengt in deze zitting door stembureaus toe te voegen, te bewerken of te verwijderen, wordt de invoerfase heropend. Bij het afronden van de invoerfase wordt een nieuw proces-verbaal gemaakt.",
    "title": "Invoerfase al afgerond"
  }
}
